// extracted by mini-css-extract-plugin
module.exports = {"discount":"locationPrice-module--discount--13G5u"};